import { useEffect, useState } from 'react';

// Service
import ClosuresService from "../../services/ClosuresService";

const useClosure = (closureId) => {
    const [closure, setClosure] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getFromServer = () => {
            setLoading(true);
            ClosuresService
                .GetByClosureId(closureId)
                .then(res => {
                    setClosure({
                        ...res,
                        arching: {
                            ...res.arching
                        }
                    });
                })
                .finally(() => setLoading(false))
        }

        if (closureId) getFromServer();
    }, [closureId]);

    return {
        closure,
        loading,
    };
}

export default useClosure;
